import { useEffect, useState } from "react";

function DrawerShell({ open, onClose, children }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <div className="absolute right-0 top-0 h-full w-full max-w-xl bg-white shadow-2xl border-l">
        {children}
      </div>
    </div>
  );
}

const ROLE_OPTIONS = [
  { label: "Doctor", value: "DOCTOR" },
  { label: "Staff", value: "STAFF" },
];

export default function UserAccessDrawer({
  open,
  user,
  saving,
  onClose,
  onSave, // ({ role }) => void
}) {
  const [role, setRole] = useState("STAFF");

  useEffect(() => {
    if (!open) return;
    setRole(user?.role || "STAFF");
  }, [open, user?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <DrawerShell open={open} onClose={saving ? undefined : onClose}>
      <div className="h-full flex flex-col">
        {/* Header */}
        <div className="p-5 border-b flex items-start justify-between gap-3">
          <div>
            <div className="text-lg font-semibold text-slate-900">
              Edit access
            </div>
            <div className="text-sm text-slate-600">{user?.email}</div>
          </div>

          <button
            className="px-3 py-2 rounded-xl border hover:bg-slate-50 disabled:opacity-50"
            onClick={onClose}
            disabled={saving}
          >
            Close
          </button>
        </div>

        {/* Body */}
        <div className="p-5 overflow-auto flex-1 space-y-6">
          {/* Role */}
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">
              Role
            </label>
            <select
              className="w-full border rounded-xl px-3 py-2.5 bg-white disabled:opacity-50"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              disabled={saving}
            >
              {ROLE_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
            <div className="mt-1 text-[11px] text-slate-500">
              Role defines the user type.
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-5 border-t flex items-center justify-end gap-2">
          <button
            className="px-4 py-2.5 rounded-xl border hover:bg-slate-50 disabled:opacity-50"
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2.5 rounded-xl text-white bg-black disabled:opacity-50"
            onClick={() => onSave?.({ role })}
            disabled={saving}
          >
            {saving ? "Saving…" : "Save changes"}
          </button>
        </div>
      </div>
    </DrawerShell>
  );
}
